import React from 'react';
import { Routes, Route } from 'react-router';
import Index from './index';
import SetNewPassword from './components/setNewPassword';
import ForgotPassowrd from './components/forgotPassword';
import SuperAdminLogin from './components/superAdminLogin'
import Login from './components/login';
import { LoginProvider } from './context';
import { GoogleOAuthProvider } from '@react-oauth/google';

const Main = () => {
  return (
    <GoogleOAuthProvider clientId="1036331443324-40ferq9h9blulrp9rg9ogj4mjbt8v0al.apps.googleusercontent.com">
      <LoginProvider>
        <Routes>
          <Route path="/" element={<Index />}>
            <Route index element={<Login />} />
            <Route path="/setNewPassword" element={<SetNewPassword />} />
            <Route path='/forgotPassword' element={<ForgotPassowrd />} />
            <Route path='/superAdminLogin' element={<SuperAdminLogin />} />
          </Route>
        </Routes>
      </LoginProvider>
    </GoogleOAuthProvider>
  );
};

export default Main;